import { Box, Fade, Typography } from '@material-ui/core';
import LockButton from '../../charting/components/LockButton';
import { Lock } from '@material-ui/icons';
import { chartingStore, useChartingSession } from '../../charting/Charting';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { CurrentTime } from '../../charting/components';

const FooterSession = () => {
  const classes = useStyles();
  const session = useChartingSession();

  return (
    <Box className={classes.footer} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Fade in={!!session}>
        <Typography>Editing as {session && (session.name || '')}</Typography>
      </Fade>
      <Fade in={!!session}>
        <div style={{ justifyContent: 'center' }}>
          <LockButton
            startIcon={<Lock style={{ color: 'rgb(0, 167, 247)' }} />}
            onClick={() => chartingStore.setState({ session: null })}
          >
            Lock
          </LockButton>
        </div>
      </Fade>
      <div style={{ justifyContent: 'flex-end' }}>
        <CurrentTime />
      </div>
    </Box>
  );
};

export const useStyles = makeStyles(theme => ({
  footer: {
    display: 'flex',
    height: theme.spacing(3),
    gap: theme.spacing(3),
    '& > *': {
      flex: 1,
      display: 'flex',
    },
  },
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(5),
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(4, 5),
    },
    gap: theme.spacing(4),
  },
}));

export default FooterSession;
